import { forwardRef } from 'react';
import { cn } from '@/lib/cn';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  leadingIcon?: React.ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(props, ref) {
  const { className, leadingIcon, ...rest } = props;
  if (leadingIcon) {
    return (
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-brand-400">
          {leadingIcon}
        </div>
        <input
          ref={ref}
          className={cn(
            'block h-9 w-full rounded-md border border-brand-200 bg-white pl-9 pr-3 text-sm text-brand-900 placeholder:text-brand-400',
            'focus:border-accent-500 focus:outline-none focus:ring-2 focus:ring-accent-500/20',
            'disabled:bg-brand-50 disabled:opacity-60',
            className,
          )}
          {...rest}
        />
      </div>
    );
  }
  return (
    <input
      ref={ref}
      className={cn(
        'block h-9 w-full rounded-md border border-brand-200 bg-white px-3 text-sm text-brand-900 placeholder:text-brand-400',
        'focus:border-accent-500 focus:outline-none focus:ring-2 focus:ring-accent-500/20',
        'disabled:bg-brand-50 disabled:opacity-60',
        className,
      )}
      {...rest}
    />
  );
});

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(props, ref) {
  const { className, rows = 3, ...rest } = props;
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(
        'block w-full rounded-md border border-brand-200 bg-white px-3 py-2 text-sm text-brand-900 placeholder:text-brand-400',
        'focus:border-accent-500 focus:outline-none focus:ring-2 focus:ring-accent-500/20',
        'disabled:bg-brand-50 disabled:opacity-60',
        className,
      )}
      {...rest}
    />
  );
});
